import React from "preact";

interface MOImportIconProps {
  fill: string;
}

export default function MOImportIcon({fill} : MOImportIconProps) {
  return  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill={fill ? fill : '#333'} viewBox="0 0 28 28">
    <path fill={fill ? fill : '#333'} d="M23.473 19.571h-1.307a.19.19 0 00-.188.19v1.53h-15.3V5.71h15.303v1.528c0 .104.085.19.187.19h1.307a.189.189 0 00.187-.19V4.76a.752.752 0 00-.746-.76H5.746A.751.751 0 005 4.76v17.48c0 .421.333.76.746.76h17.168a.751.751 0 00.746-.76v-2.478a.189.189 0 00-.187-.19zm.333-6.962h-7.63v-1.88c0-.166-.189-.26-.315-.156l-3.448 2.771a.198.198 0 00-.075.156.201.201 0 00.075.156l3.448 2.77c.128.105.316.01.316-.155v-1.88h7.629a.197.197 0 00.194-.198v-1.386a.197.197 0 00-.194-.198z"></path>
  </svg>
}
